import { render } from "./Fitness.vue?vue&type=template&id=18597bb6"
import script from "./Fitness.vue?vue&type=script&lang=js"
export * from "./Fitness.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__